import type {
	GoalRentSummary,
	GoalRentSummaryInput,
} from "web_myplann/Goals/Types/GoalRentSummary";

export const mapToGoalRentSummary = (
	goal: GoalRentSummaryInput,
): GoalRentSummary | null => {
	if (goal.completed || !goal.rentMode || goal.monthlyRent <= 0) return null;

	return {
		isPerpetual: goal.rentYears <= 0,
		monthlyRent: goal.monthlyRent,
		rentYears: goal.rentYears,
	};
};
